// extracted by mini-css-extract-plugin
export default {"root":"_3Ouiy","discount-label":"_3CqsB","discountLabel":"_3CqsB","price":"_1V0le","old-price":"_1BUNb","oldPrice":"_1BUNb","exclusive":"_2jiZf"};